import { Dispatch } from "redux";

import { api } from "../utils/api";
import { SET_IMPERSONATED_USERS } from "../constants/actions";

export const getImpersonatedUsers = () => {
  return async function (dispatch: Dispatch) {
    try {
      const response = await api.get("impersonation/impersonationspaginated");

      dispatch({ type: SET_IMPERSONATED_USERS, payload: response.data.data });
      return response.data.data;
    } catch (e) {
      throw e;
    }
  };
};

export const postImpersonated = (ssn: string) => {
  return async function () {
    try {
      const response = await api.post(`impersonated/${ssn}?isActive=true`);

      return response.data;
    } catch (e) {
      throw e;
    }
  };
};
